import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { typography } from 'src/config/typography';
import { media } from 'src/config/breakpoints';
import { colors } from 'src/config/colors';
import { AboutUsAdditional } from 'src/common/models/aboutUsStaticPage';
import Blocks from 'editorjs-blocks-react-renderer';
import { editorjsRenderers } from 'src/config/editorjs';
import { StaticPageEditorContent } from 'src/public/components/static-page/StaticPageEditorContent';
import { prependCMSUrl } from 'src/config/cms';
import Image from 'next/image';

const Container = styled.div`
  align-items: center;
  background: ${colors.grey05};
  display: flex;
  flex-direction: column;
  padding: 5rem 0.75rem 3.75rem;
  width: 100%;

  ${media.w.min.px768(css`
    flex-direction: row;
    padding: 3.75rem 2.625rem;
  `)};
`;

const Content = styled.div`
  color: ${colors.blue};
  display: flex;
  flex-direction: column;
  width: 50%;

  ${media.w.max.px768(css`
    margin-top: 3.9375rem;
    max-width: 27rem;
    order: 2;
    padding: 0 0.75rem;
    width: 100%;
  `)};
`;

const Heading = styled.div`
  font-family: ${typography.fontFamilyHeaders};
  font-size: 1.5rem;
  line-height: 1.875rem;
  margin-top: 1rem;
`;

const ImageContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;

  ${media.w.min.px768(css`
    padding: 0 2.5rem;
    width: 50%;
  `)};

  img {
    width: 18.125rem;

    ${media.w.min.px768(css`
      width: 100%;
    `)};
  }
`;

const Subtitle = styled.div`
  color: ${colors.pfp3bis};
  font-family: ${typography.fontFamilyDefault};
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.15rem;
  line-height: 1rem;
`;

const Text = styled.div`
  font-family: ${typography.fontFamilyHeaders};
  font-size: 1rem;
  line-height: 1.375rem;

  p {
    margin: 1.875rem 0 0;
  }
`;

export interface AboutUsAdditionalOptionsProps {
  content: AboutUsAdditional;
}

export const AboutUsAdditionalOptions: FC<AboutUsAdditionalOptionsProps> = ({ content }) => (
  <Container>
    <Content>
      <Subtitle>{content.subtitle}</Subtitle>
      <Heading>{content.heading}</Heading>

      <Text>
        <StaticPageEditorContent>
          <Blocks data={content.text} renderers={editorjsRenderers} />
        </StaticPageEditorContent>
      </Text>
    </Content>

    <ImageContainer>
      <Image
        height={content.image.data.attributes.height}
        src={prependCMSUrl(content.image.data.attributes.url)}
        width={content.image.data.attributes.width}
      />
    </ImageContainer>
  </Container>
);
